import '../stylesheet/newDeviseUi.css'